import React from 'react';

import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { closeRemixModal } from './editor-commands/close-remix-modal';
import { openRemixModal } from './editor-commands/open-remix-modal';
import type { MalleableUiPlugin } from './malleableUiPluginType';
import { remixButtonDecoration } from './pm-plugins/decorations-remix-button';
import { createMalleableUiPmPlugin, malleableUiPluginKey } from './pm-plugins/plugin-key';
import { RemixContent } from './ui/components/RemixContent';
import { getOverriddenFloatingToolbarConfig } from './ui/toolbars/overridden-floating-toolbar-config';
import { getSelectionToolbarComponents } from './ui/toolbars/toolbar-components';

const REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';

export const malleableUiPlugin: MalleableUiPlugin = ({ api, config }) => {
	api?.toolbar?.actions.registerComponents(getSelectionToolbarComponents(api));

	if (api && expValEquals('confluence_remix_icon_right_side', 'isEnabled', true)) {
		api.blockControls.actions.registerNodeDecoration({
			type: REMIX_BUTTON_DECORATION_TYPE,
			create: (params) => remixButtonDecoration({ ...params, api }),
		});
	}

	return {
		name: 'malleableUi',

		pmPlugins() {
			return [
				{
					name: 'malleableUi',
					plugin: ({ dispatch }) => createMalleableUiPmPlugin(dispatch),
				},
			];
		},

		getSharedState(editorState) {
			if (!editorState) {
				return undefined;
			}
			return malleableUiPluginKey.getState(editorState);
		},

		commands: {
			openRemixModal,
			closeRemixModal,
		},

		contentComponent: () => {
			return <RemixContent api={api} config={config} />;
		},

		pluginsOptions: {
			floatingToolbar: getOverriddenFloatingToolbarConfig(api),
		},
	};
};
